import { create } from 'jss';
import { jssPreset } from '@material-ui/styles';
import rtl from 'jss-rtl';

export const jss = create({
    plugins: [...jssPreset().plugins, rtl()] as any[],
    insertionPoint: 'jss-insertion-point',
});
